module.exports = __webpack_public_path__ + "Roboto-700.7f57c4c0f3b44acbe338.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.svg
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.svg
// module chunks = main styles